// extracted by mini-css-extract-plugin
export var messageSideLeft = "_o1-1";
export var messageSideRight = "_o1-2";
export var orderLookupBubbleContainer = "_o1-0";
export var submitButton = "_o1-3";